import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const MOCKTEST_URL = "https://fetc.in/api/v1/mocktest";

export const mockTestApi = createApi({
  reducerPath: "mockTestApi",
  tagTypes: ["MockTests"],

  baseQuery: fetchBaseQuery({
    baseUrl: MOCKTEST_URL,
    credentials: "include",
  }),

  endpoints: (builder) => ({

/* -----------------------------------------
   CREATE MOCK TEST
----------------------------------------- */
createMockTest: builder.mutation({
  query: (data) => ({
    url: "/create",
    method: "POST",
    body: data,
  }),
  invalidatesTags: ["MockTests"],
}),

/* -----------------------------------------
   GET ALL MOCK TESTS (ADMIN)
----------------------------------------- */
getMockTests: builder.query({
  query: () => "/list",
  providesTags: ["MockTests"],
}),

/* -----------------------------------------
   GET PUBLISHED MOCK TESTS (USER)
----------------------------------------- */
getPublishedMockTests: builder.query({
  query: () => "/published",
  providesTags: ["MockTests"],
}),

/* -----------------------------------------
   GET SINGLE MOCK TEST
----------------------------------------- */
getMockTestById: builder.query({
  query: (id) => `/${id}`,
  providesTags: (result, error, id) => [
    { type: "MockTests", id }
  ],
}),

/* -----------------------------------------
   UPDATE MOCK TEST
----------------------------------------- */
editMockTest: builder.mutation({
  query: ({ id, data }) => ({
    url: `/${id}`,
    method: "PUT",
    body: data,
  }),
  invalidatesTags: (r, e, { id }) => [
    { type: "MockTests", id },
    "MockTests",
  ],
}),

/* -----------------------------------------
   DELETE MOCK TEST
----------------------------------------- */
deleteMockTest: builder.mutation({
  query: (id) => ({
    url: `/${id}`,
    method: "DELETE",
  }),
  invalidatesTags: ["MockTests"],
}),

/* -----------------------------------------
   FILE UPLOAD
----------------------------------------- */
uploadMockTestImage: builder.mutation({
  query: (formData) => ({
    url: "/upload/image",
    method: "POST",
    body: formData,
  }),
}),

  }),
});

/* -----------------------------------------
   EXPORTED HOOKS
----------------------------------------- */

export const {
  useCreateMockTestMutation,
  useGetMockTestsQuery,
  useGetPublishedMockTestsQuery,
  useGetMockTestByIdQuery,
  useEditMockTestMutation,
  useDeleteMockTestMutation,
  useUploadMockTestImageMutation,
} = mockTestApi;
